
<script setup>
import CmsText from '@/@core/components/CmsText.vue'
</script>

<template>
  <section class="pb-8 ml-1 mr-1">
    <div class="content-wrapper">
      <CmsText
        k="home.overview.membersTitle"
        tag="h2"
        class="section-subtitle text-center mt-8"
      />
      <CmsText
        k="home.overview.sportsEntText"
        tag="div"
        class="section-subtitle text-center mt-2"
      />
    </div>
    <CmsText
      k="home.overview.luxuryDinersText"
      tag="div"
      class="section-subtitle text-center mt-1"
    />
    <div class="content-wrapper">
      <CmsText
        k="home.overview.trustTitle"
        tag="h2"
        class="section-subtitle text-center mt-8"
      />
      <CmsText
        k="home.overview.preferredText"
        tag="div"
        class="section-subtitle text-center mt-2"
      />
      <CmsText
        k="home.overview.eventsText"
        tag="div"
        class="section-subtitle text-center mt-2"
      />
      <CmsText
        k="home.overview.insightsText"
        tag="div"
        class="section-subtitle text-center mt-2"
      />
      <div class="section-subtitle text-center mt-2">
        <RouterLink
          class="text-primary"
          :to="{ name: 'members' }"
        >
          <CmsText k="home.overview.viewMoreLink" />
        </RouterLink>
      </div>
    </div>
  </section>
</template>


